import { WhmButtonProps, WhmLoadingButton } from "@securitize/reactjs-whm";
import React from "react";

interface CustomWhmLoadingButtonProps {
  onClick?: () => void;
  loading: boolean;
  disabled?: boolean;
  variant?: WhmButtonProps["variant"];
  color?: WhmButtonProps["color"];
  children?: React.ReactNode;
}

export const CustomWhmLoadingButton = ({
  onClick,
  loading,
  disabled,
  variant,
  color,
  children,
}: CustomWhmLoadingButtonProps) => (
  <WhmLoadingButton
    loading={loading}
    variant={variant}
    onClick={onClick}
    disabled={disabled}
    color={color}
    loadingPosition="start"
    sx={{
      minWidth: "fit-content !important",
      svg: {
        display: "block !important",
      },
      "&.MuiLoadingButton-root .MuiLoadingButton-loadingIndicator.MuiLoadingButton-loadingIndicatorCenter":
        {
          position: "absolute !important",
        },
    }}
  >
    {children}
  </WhmLoadingButton>
);
